module.exports = __webpack_public_path__ + "7769167a7c3cfac234fb2e6944dc9cdf.png";